export class SortPipelineHistoryBy {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "field",
            "baseName": "field",
            "type": "PipelineHistorySortField",
            "format": ""
        },
        {
            "name": "order",
            "baseName": "order",
            "type": "PipelineHistorySortOrder",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SortPipelineHistoryBy.attributeTypeMap;
    }
    constructor() {
    }
}
